import { Inject } from '@odinjs/odin';

import { ENDPOINTS } from '@philips-emr/hpms-health-insurance-commons';
import { HpmsTextHtmlAPI } from '@philips-emr/hpms-health-insurance-components';
import { ToastNotificationAPI } from '@philips-emr/tws-components';
import { ToastLevel } from '@philips-emr/tws-constants';
import Controller, { OnAfterFetch, OnCancel, OnSubmit } from '@philips-emr/tws-core/lib/client';
import { FetchEvent, SubmitEvent } from '@philips-emr/tws-core/lib/component/types';
import { AuthenticationService, HttpService, MessageService, ModalService } from '@philips-emr/tws-core/lib/services';

import { FragmentNames } from '../codegen';
import { AssingTermAliases as Aliases } from '../codegen/constants/aliases/assing-term-aliases';
import { BaseRoute } from '../route';
import { ToastService } from '../services';
import TermsService from '../services/terms-service';

import BaseController from './BaseController';

interface Term {
  dsTerm: string,
  nrSequence: number,
}

@Controller({ fragment: FragmentNames.ASSING_TERM })
export default class AssingTermControler extends BaseController {

  @Inject(Aliases.HPMS_TEXT_HTML_TERM)
  private textHtml: HpmsTextHtmlAPI;
  @Inject(Aliases.TOAST_NOTIFICATION)
  private toast: ToastNotificationAPI;

  @OnAfterFetch(Aliases.FETCH_TERM)
  onMountTermoTexto(event: FetchEvent): void {
    const { dsTerm } = event.data as Term;
    this.textHtml.setData(dsTerm);
  }

  @OnSubmit(Aliases.FORM_TERM)
  onSubmitTerm(event: SubmitEvent): void {
    const { record } = event;

    if (!record || !record.checked) {
      this.toast.setVisible(true);
      this.scrollDownPanelTerm();
      return;
    }

    HttpService.post(ENDPOINTS.POST.TERMS, {}, { body: record }).then(() => {
      ModalService.close('term-modal');
      TermsService.checkTerms();
    }).catch((error) => ToastService.open({ message: error.body, level: ToastLevel.ERROR }));
  }

  @OnCancel(Aliases.FORM_TERM)
  onclose(): void {
    AuthenticationService.logout().then(() => {
      this.historyService.push(BaseRoute.LOGIN);
    }).catch(() => ToastService.open({ message: MessageService.translate('hi.error'), level: ToastLevel.ERROR }));
  }

  scrollDownPanelTerm(): void {
    const termPanel = document.querySelector<HTMLDivElement>('.c-modal__content--with-stack-manager');
    if (termPanel) {
      const { scrollHeight } = termPanel;
      termPanel.scrollTo({ top: scrollHeight, behavior: 'smooth' });
    }
  }
}
